import SectionHeader from "../Common/SectionHeader";

const CollectionsHeader = ({ title, subtitle, actionLabel, onAction, actionDisabled = false }) => {
    return (
        <SectionHeader
            title={title}
            subtitle={subtitle}
            actionLabel={actionLabel}
            onAction={onAction}
            actionDisabled={actionDisabled}
        />
    );
};

export default CollectionsHeader;
